// Generic Promise-over-postMessage RPC client. Main-thread code talks to
// src/workers/*.worker.js only through this — never postMessage directly,
// never touch worker internals.
let nextId = 1;

export function createRpcClient(worker) {
  const pending = new Map();

  worker.addEventListener('message', (event) => {
    const { id, ok, result, error } = event.data || {};
    const entry = pending.get(id);
    if (!entry) return;
    pending.delete(id);
    if (ok) entry.resolve(result);
    else entry.reject(new Error(error || 'Worker call failed'));
  });

  worker.addEventListener('error', (event) => {
    for (const [id, entry] of pending) {
      entry.reject(new Error(event.message || 'Worker error'));
      pending.delete(id);
    }
  });

  return function call(method, params) {
    const id = nextId++;
    return new Promise((resolve, reject) => {
      pending.set(id, { resolve, reject });
      worker.postMessage({ id, method, params });
    });
  };
}
